import axios from 'axios';

const BASE_URL = '/app/funnelConfig';

export const createConfig = async (funnelId, opensAutomatically) => {
    const { data } = await axios.post(`${BASE_URL}/create/${funnelId}?opensAutomatically=${opensAutomatically}`);

    return data;
};

export const getConfig = async (funnelId) => {
    const { data } = await axios.get(`${BASE_URL}/${funnelId}`);

    return data;
};
